const LIBRARY_VERSION =
    process.env.LIBRARY_VERSION ||
    // фиксированная версия для юнит-тестов
    '0';

/**
 * Глобальный класс, ограничивающий действие всех селекторов библиотеки (кроме исключённых), своими пределами
 */
export const classHrComponentsVersion = `HR-${LIBRARY_VERSION.replaceAll('.', '-')}`;
